// Description: Endpoint to signup
// Updated: 21/08/2025
// Author: Simon Franklin

import axios from 'axios';

export async function AuthSignup(data) {
    try {
        const response = await axios.post(
            `${process.env.REACT_APP_BACKEND_AWS_URL}/auth/create`, 
            data,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        if (error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('Erro inesperado. Tente novamente mais tarde.' )
        }
    }
}